import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Card from './../components/Commanbackgroundcard/Card';
import Form from '../components/Form/Form';
import './Contactuspage.css';
import Footer from '../components/Footer/Footer';

const ContactCard = ({ icon, title, content, link, linkText }) => (
  <div className="contact-card">
    <div className="card-icon">{icon}</div>
    <h3 className="card-title">{title}</h3>
    <p className="card-content">{content}</p>
    {link && <a href={link} className="card-link">{linkText}</a>}
  </div>
);

const Contactuspage = () => {
  return (
    <div className="contact-page min-h-screen">
      <Navbar />
      <Card text="GET IN TOUCH" />
      

      {/* Contact Cards Section */}
      <div className="contact-grid">
        <ContactCard 
          icon="📞"
          title="Call Us"
          content="Need immediate assistance?"
          link="tel:+919665467137"
          linkText="+91 966 546 7137"
        />
        <ContactCard 
          icon="✉️"
          title="Email Us"
          content="Get in touch via email"
          link="mailto:tushar.gholap@metrolabautomation.com"
          linkText="tushar.gholap@metrolabautomation.com"
        />
        <ContactCard 
          icon="🏢"
          title="Visit Us"
          content="29/13, D-Block, MIDC, Chinchwad, Pune (MH) 411019, India"
        />
      </div>

      {/* Form + Map Section */}
      <div className="main-content">
        {/* Left Side - Form */}
        <div className="form-section">
          <h2 className="section-title mb-4">Send us a Message</h2>
          <p className="section-desc mb-6">Fill out the form below and we'll get back to you within 24 hours</p>
          <div className="privacy-note mb-4">
            All information provided is for our use only. We do not share this information with outside parties.
          </div>
          <Form />
        </div>

        {/* Right Side - Contact Info + Map */}
        <div className="contact-info-container">
          <p>
            <strong className="mr-2">Email:</strong>
            <a href="mailto:tushar.gholap@metrolabautomation.com" className="contact-link">
              tushar.gholap@metrolabautomation.com
            </a>
          </p>
          <p>
            <strong>Phone: </strong>
            <a href="tel:+919665467137" className="contact-link">
              +91 966 546 7137
            </a>
          </p>

          <div className="mt-4">
            <strong>Mail:</strong>
            <p>Metrolab Automation Pvt. Ltd.</p>
            <p>29/13, D-Block, MIDC</p>
            <p>Chinchwad, Pune (MH) 411019, India</p>
          </div>

          <div className="mt-4">
            <strong>24/7 Urgent or Emergency after hours:</strong>
            <p>Tech Support, Plant Down</p>
            <p className="emergency-info text-red-600 italic">
              Our on-call engineer will call you back immediately.
            </p>
          </div>

          <div className="map-container">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3780.3336253279463!2d73.80374297372406!3d18.649019065240996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b83a646e8dd3%3A0x3ee74f3f89e74abd!2sMetrolab%20Automation%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1760002319231!5m2!1sen!2sin"
              width="100%" 
              height="300" 
              style={{border:0}} 
              allowFullScreen="" 
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Metrolab Location"
              className="w-full shadow-lg"
            ></iframe>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Contactuspage;
